import intl from 'react-intl-universal';
import {
  viewColumn,
  caseTitleColumn,
  deadlineColumn,
  orderTimeColumn,
  returnedTimeColumn,
  stateColumn,
} from '../commonColumns';
import {
  getIssueStatusForClient,
  IssueStatusToOrder,
  IssueStatusForClient,
} from 'shared/constants/issues';
import { Status } from 'components/Status/styles';
import PropTypes from 'prop-types';
import logger from 'utils/logger';

const log = logger.createLogger('SentHistoryTableColumns');

export const sentStatusColumn = (filterSelectOptions) => ({
  accessorKey: 'status',
  header: intl.get('case_list_label_column_status'),
  filterVariant: 'select',
  enableSorting: true,
  enableFacetedValues: false,
  sortingFn: (rowA, rowB, columnId) => {
    const order1 = IssueStatusToOrder[rowA.getValue(columnId)];
    const order2 = IssueStatusToOrder[rowB.getValue(columnId)];
    return order1 === order2 ? 0 : order1 > order2 ? 1 : -1;
  },
  filterSelectOptions: filterSelectOptions,
  Cell: sentStatusCell,
});

const sentStatusCell = ({ row }) => {
  const statusValue = row.getValue('status');
  return (
    <Status color={statusValue}>{getIssueStatusForClient(statusValue)}</Status>
  );
};

sentStatusCell.propTypes = {
  row: PropTypes.object.isRequired,
};

export const getSentTableColumns = (handleOpenIssueDetails) => [
  caseTitleColumn(),
  {
    accessorKey: 'patientName',
    header: intl.get('case_list_label_column_patient_name'),
    enableSorting: true,
    filterVariant: 'textField',
    filterFn: 'fuzzy',
    enableFacetedValues: false,
  },
  sentStatusColumn([
    {
      label: intl.get('shared_value_status_new_task'),
      value: IssueStatusForClient.NEWTASK,
    },
    {
      label: intl.get('shared_value_status_in_progress'),
      value: IssueStatusForClient.INPROGRESS,
    },
    {
      label: intl.get('shared_value_status_send_back'),
      value: IssueStatusForClient.SENDBACK,
    },
    {
      label: intl.get('shared_value_status_done'),
      value: IssueStatusForClient.DONE,
    },
  ]),
  stateColumn(),
  orderTimeColumn(),
  returnedTimeColumn(),
  deadlineColumn(),
  {
    accessorKey: 'to_hospital',
    header: intl.get('case_list_label_column_to'),
    filterVariant: 'multi-select',
    enableFacetedValues: true,
  },
  viewColumn(handleOpenIssueDetails),
];
